
import { FormGroup, FormArray, Validators } from '@angular/forms';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NofeshService } from './../nofesh.service';
import { Component, OnInit } from '@angular/core';
import { ITashlum } from './../model/tashlum';
import { MenuHandler } from "app/shared/menu-handler";
declare var $: any;

@Component({
    moduleId: module.id,
    templateUrl: './nofesh-payment.component.html'
})

export class NofeshPaymentComponent implements OnInit {
    reservationId: number;
    id_nofesh: number;
    amit_count: number; price_amit: number;
    nilve_count: number; price_nilve: number;
    amitim: any[];
    price_tip: number;
    price_visa: number;
    price_singel: number;
    errorMessage: string;
    is_submited: boolean = false;
    isvalidform: boolean = true;
    is_hamtana: boolean = false;
    dolar_rate: number;
    form: FormGroup;
    miss_sum: number = 0;
    ms_zehut_mazmim: number;
    // currentYear: number = new Date().getFullYear();
    // months = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"]
    // years = [this.currentYear.toString(), (this.currentYear + 1).toString(), (this.currentYear + 2).toString(), (this.currentYear + 3).toString(), (this.currentYear + 4).toString(), (this.currentYear + 5).toString(), (this.currentYear + 6).toString(), (this.currentYear + 7).toString(), (this.currentYear + 8).toString()]







    constructor(private _activateRoute: ActivatedRoute, private _router: Router, private fb: FormBuilder, private _http: NofeshService) { }


    ngOnInit() {

        MenuHandler.menuHandler($(".wiz_group"), $("#li_pirtey_tashlum"));

        //debugger;
        this.form = this.fb.group({
            nofesh_id: 0,
            ms_zehut_mazmin: 0,
            tashlumim: this.fb.array([
            ])
        })


        let orderNofesh = sessionStorage.getItem('order-nofesh');
        if (orderNofesh != null && orderNofesh !== undefined) {
            this.reservationId = JSON.parse(orderNofesh).id_reservation;
            this.id_nofesh = JSON.parse(orderNofesh).id_nofesh;
            this.ms_zehut_mazmim = JSON.parse(orderNofesh).nirshamim[0].ms_zehut;
            this.is_hamtana = JSON.parse(orderNofesh).is_hamtana;
            this.form.controls['nofesh_id'].patchValue(this.id_nofesh);
            this.form.controls['ms_zehut_mazmin'].patchValue(this.ms_zehut_mazmim);
            this._http.getNofeshPayment(this.id_nofesh)
                .subscribe(res => {

                    console.log(res);

                    sessionStorage.setItem('nofeshPayments', JSON.stringify(res));
                    this.amitim = res.nofeshPayment.filter(nirsham => nirsham.amit == 1)
                    this.amit_count = res.nofeshPayment.filter(nirsham => nirsham.amit == 1).length
                    this.nilve_count = res.nofeshPayment.filter(nirsham => nirsham.amit == 0).length
                    this.price_amit = res.nofeshPayment.find(nirsham => nirsham.amit == 1) !== undefined ? res.nofeshPayment.find(nirsham => nirsham.amit == 1).main_price : 0
                    this.price_nilve = res.nofeshPayment.find(nirsham => nirsham.amit == 0) !== undefined ? res.nofeshPayment.find(nirsham => nirsham.amit == 0).main_price : 0
                    this.price_tip = res.nofeshPayment.find(nirsham => nirsham.price_tip > 0) != undefined ? res.nofeshPayment.find(nirsham => nirsham.price_tip > 0).price_tip : 0
                    this.price_visa = res.nofeshPayment.find(nirsham => nirsham.price_visa > 0) != undefined ? res.nofeshPayment.find(nirsham => nirsham.price_visa > 0).price_visa : 0
                    this.dolar_rate = res.nofeshPayment.find(nirsham => nirsham.dolar_rate > 0) != undefined ? res.nofeshPayment.find(nirsham => nirsham.dolar_rate > 0).dolar_rate : 0
                    
                    if ((this.amit_count + this.nilve_count) > 1) 
                    {
                        this.price_singel = 0;
                    }
                    else 
                    {
                        this.price_singel = res.nofeshPayment.find(nirsham => nirsham.price_singel > 0) != undefined ? res.nofeshPayment.find(nirsham => nirsham.price_singel > 0).price_singel : 0

                    }

                    if (res.nofeshTashlumim.length > 0) 
                    {
                        res.nofeshTashlumim.forEach(t => this.addTashlum(t));
                    }
                    else 
                    {
                        let count = this.amitim.length;
                        let schum_tashlum: number = ((this.price_amit * this.amit_count) + (this.price_nilve * this.nilve_count) + (this.price_tip * (this.amit_count + this.nilve_count)) + (this.price_visa * (this.amit_count + this.nilve_count)) + (this.price_singel * (this.amit_count + this.nilve_count))) / count;
                        if (count > 0) 
                        {
                            for (let amit of this.amitim) {
                                this.addTashlum(this.CreateTashlum(amit.ms_zehut, schum_tashlum));
                            }
                        }
                    }
                })
        }
        else { return this._router.navigate(['nofesh']); }
    }

    getNofeshPayment() {
        let orderNofesh = sessionStorage.getItem('order-nofesh');
    }


    // validationChange(event){
    //     debugger;
    //     this.isvalidform = event;
    // }


    get tashlumim() { return <FormArray>this.form.controls['tashlumim']; }

    InitTashlum(tashlum: ITashlum) {
        let fg: FormGroup;
        if (tashlum) {
            fg = this.fb.group({
                ms_zehut_meshalem: [tashlum.ms_zehut_meshalem, Validators.required],
                ofen_tashlum: [tashlum.ofen_tashlum.toString()],
                ms_tashlumim: [tashlum.ms_tashlumim, Validators.required],
                schum_tashlum: [tashlum.schum_tashlum, Validators.required],
                teur_tashlum: [tashlum.teur_tashlum]

            })
        }
        else {
            fg = this.fb.group({
                ms_zehut_meshalem: ["", Validators.required],
                ofen_tashlum: ['2'],
                ms_tashlumim: [1, Validators.required],
                schum_tashlum: [0, Validators.required],
                teur_tashlum: [""]

            })
        }
        return fg;
    }
    addTashlum(item: ITashlum) {
        const control = <FormArray>this.form.controls['tashlumim'];
        control.push(this.InitTashlum(item));
    }
    removeTashlum(index: number) {
        const control = <FormArray>this.form.controls['tashlumim'];
        control.removeAt(index);
    }

    CreateTashlum(ms_zehut?: number, schum_tashlum?: number) {
        //debugger;
        return {
            ms_zehut_meshalem: (ms_zehut) ? ms_zehut : 0,
            ofen_tashlum: 1,
            ms_tashlumim: 1,
            schum_tashlum: (schum_tashlum) ? schum_tashlum : 0,
            teur_tashlum: ""
        }
    }

    save(event, { value, valid }: { value: any, valid: boolean }): void {

        event.preventDefault();
        this.is_submited = true;
        this.errorMessage = null;

        if (!valid) {
            this.isvalidform = false;
            this.errorMessage = 'נא למלא את כל שדות החובה באופן תקין';
            this.is_submited = false;
            return;
        }

        if (!this.ValidateSum()) {
            this.isvalidform = false;
            this.errorMessage = 'הסכומים שהוזנו אינם תואמים לסכום הנופש - ' + 'קיים פער של ' + '₪' + this.miss_sum;
            this.is_submited = false;
            return;
        }

        this._http.saveNofeshTashlumim(value)
            .subscribe(res => {
                if (res.status) {
                    sessionStorage.setItem('nofesh-tashlumim', JSON.stringify(res));
                }
                // this._router.navigate(['nofesh', 'nofesh-uploads']);
                this._router.navigate(['nofesh', 'end-rishum']);
            },
            error => {
                //debugger;
                console.log(error);
                if (error.includes("401")) {
                    localStorage.removeItem("token");
                    location.reload();
                }

                this.isvalidform = false;
                this.errorMessage = 'נא לבדוק שכל השדות מולאו כפי שצריך או לנסות מאוחר יותר';
                this.is_submited = false;
            })


    }

    ValidateSum() {
        let tashlumim = (<FormArray>this.form.controls['tashlumim']).controls;
        let sum: number = 0;

        for (var tashlum of tashlumim) {
            sum += +(<FormGroup>tashlum).controls['schum_tashlum'].value;
        }

        let nofesh_price: number = (this.price_amit * this.amit_count) + (this.price_nilve * this.nilve_count) + (this.price_tip * (this.amit_count + this.nilve_count)) + (this.price_visa * (this.amit_count + this.nilve_count)) + (this.price_singel * (this.amit_count + this.nilve_count));

        if (sum == nofesh_price) {
            return true;
        }
        else {
            if (sum > nofesh_price)
                this.miss_sum = sum - nofesh_price;
            else
                this.miss_sum = nofesh_price - sum;

            return false;
        }

    }

    menuHandler(t, id) {
        $("#menu_ul_id").find('li').removeClass("wiz-selected-step");
        $("#menu_ul_id").find(".wiz-num").removeClass("wiz-selected-num");

        id.toggleClass('wiz-selected-step');
        id.find(".wiz-num").toggleClass("wiz-selected-num");

        $(t).find('small.fa').remove()


        if ($(t).find('.wiz-selected-step').length == 0)
            return;
        var index = $(t).find('.wiz-selected-step').index();
        var amount = parseInt($(t).find('.wiz_group').data('wiz-steps'));
        if (amount <= 0)
            return;
        var colWidth = 100 / amount * 0.99;
        $(t).find('.wiz_group').append('<small class="fa fa-caret-down wiz-current-indiction" style="width:' + colWidth + '%; margin-right:' + (colWidth * (index)) + '%;"></small>');

        this._setWizardSteps();

        this.updateHeaderTitle();
    }

    _setWizardSteps() {

        var $wizGroup = $('.wiz_group');
        if (!$wizGroup || !$wizGroup.data('wiz-steps'))
            return;
        var stepsCount = parseInt($wizGroup.data('wiz-steps'));
        var $steps = $('.wiz_group>ol>li');

        if ($steps.length > 0) {
            $steps.css('width', 100 / stepsCount + '%');
            $('.wiz-current-indiction').css('width', 100 / stepsCount + '%');

            var nextStepText = $($steps[1]).find('.wiz-text').text();
            $('.next-step').attr('title', nextStepText);
        }
    }

    updateHeaderTitle() {
        var wiz_num = $(".wiz-selected-num");
        var wiz_text = $(".wiz-selected-num").next();

        if (wiz_num.text().length > 0 && wiz_text.text().length > 0) {
            var title = $("#layouHeader").attr("title")
            title = title + " שלב " + wiz_num.text() + " - " + wiz_text.text();
            $("#layouHeader").attr("title", title);
        }
        else {
            $("#layouHeader").attr("title", "עיריית תל אביב - רישום גני ילדים וחינוך יסודי");
        }
    }
}